export default __webpack_public_path__ + "static/media/card-back.af4b9fbb.svg";